import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import axios from "axios";
import { useCookies } from "react-cookie";

import { request } from "../../api";

import styles from "./CookieNotification.module.scss";

const CookieNotification = ({ onShowChange }) => {
  const [cookies, setCookie, removeCookie] = useCookies([]);

  const [showCookie, toggleCookie] = useState(
    typeof cookies["allowed_metrika"] !== "undefined" ? false : true
  );

  const [errorMsg, setErrorMsg] = useState(true);

  const prevShowRef = useRef(showCookie);

  const accept = () => {
    console.log("cookie приняты");
    send_request(true, 31622400000); // 1 год
  };

  const reject = () => {
    console.log("cookie отклонены");
    send_request(false, 180000); // 3 минуты
  };

  useEffect(() => {
    // if (!cookies.hasOwnProperty('allowed_metrika')) {

    axios
      .get(`${request}/check-cookies`, { withCredentials: true, origin: true })
      .then((response) => {
        if (response.statusText === "OK") {
          // toggleCookie(
          //   typeof response.data.allowed_metrika === "boolean"
          //     ? response.data.allowed_metrika
          //     : true
          // );
          onShowChange(
            typeof response.data.allowed_metrika === "boolean"
              ? response.data.allowed_metrika
              : true
          );
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        console.log(error);
        toggleCookie(true);
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {});
  }, [cookies, request]);

  const send_request = (val, age) => {
    axios
      .post(`${request}/set-allow`, { allowed_cookies: val })
      .then((response) => {
        if (response.statusText === "OK") {
          // setCookie('allowed_metrika', val, { secure: false, 'max-age': age, 'SameSite': 'Lax' } );
          setCookie("allowed_metrika", val, {
            secure: false,
            "max-age": age,
            SameSite: "Lax",
            domain: ".proektmarketing.ru",
          });

          onShowChange(false);
        } else {
          setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMsg("Произошли ошибки, пожалуйста попробуйте позже.");
      })
      .finally(() => {
        toggleCookie(false);
      });
  };

  if (showCookie) {
    return (
      <div className={styles.CookieNotification}>
        <div className="holder no-pdn-top holder_without-mobile">
          <div className={styles.Container}>
            <p className={styles.Message}>
                Продолжая пользоваться данным сайтом выражаю согласие на&nbsp;обработку персональных данных посредством Яндекс.Метрика в&nbsp;соответствии с&nbsp;<a href="/pages/privacy-policy">политикой конфиденциальности</a>, а&nbsp;также проинформирован об&nbsp;использовании Cookie-файлов
            </p>

            <div className={styles.Controls}>
              <button
                className={classNames(styles.Button, styles.ButtonWithMargin)}
                onClick={() => accept()}
              >
                Принять
              </button>
              {/* <button className={styles.Button} onClick={() => reject()}>Отклонить</button> */}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default CookieNotification;
